/**
 * PAUSE-PLATEAU — lecture PURE du refus « plateau en pause » du serveur : 403
 * dont le corps porte `code: 'TENANT_PAUSED'` (`telephony/tenant-pause.ts`
 * backend, préservé par le filtre HTTP global). Toute autre 403 (gating
 * d'essai…) ou toute autre erreur → `false`.
 *
 * Module SANS dépendance : partagé par le provider (refus de composition) et
 * par `useNextContact` (refus du contact suivant) sans créer de cycle avec
 * `TelephonyProvider.tsx`.
 */
export function readTenantPaused(error: unknown): boolean {
  const response = (
    error as { response?: { status?: unknown; data?: unknown } } | null
  )?.response
  if (!response || response.status !== 403) return false
  const data = response.data as { code?: unknown } | null | undefined
  return data?.code === 'TENANT_PAUSED'
}
